
  var _styles = {
  "pj-landmark": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "column",
    "width": "1.65333rem",
    "height": "1.6rem",
    "borderRadius": "0.21333rem",
    "backgroundColor": "rgb(255,243,245)",
    "overflow": "hidden"
  },
  "pj-landmark__bg": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "1.65333rem",
    "height": "1.6rem",
    "zIndex": 0
  },
  "pj-landmark__mask": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "1.65333rem",
    "height": "1.6rem",
    "backgroundColor": "rgba(0,0,0,0.45)",
    "zIndex": 1
  },
  "pj-landmark__band": {
    "position": "absolute",
    "bottom": 0,
    "left": 0,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "1.65333rem",
    "height": "0.50667rem",
    "backgroundColor": "rgb(106,188,255)",
    "zIndex": 2
  },
  "pj-landmark__name": {
    "textAlign": "center",
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.26667rem"
  }
};



  module.exports = _styles;
  